import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Phone = ({
  color = colors.grey90,
  height = 750,
  isColorInherited = false,
  opacity = 1,
  width = 400,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 400 750" {...props}>
    <g fill="#FFF">
      <rect width="400" height="750" rx="32" />
      <rect
        fill={getColor(color, isColorInherited)}
        height="612"
        opacity={opacity}
        rx="20"
        stroke="#D9D9D9"
        strokeWidth="4"
        width="350"
        x="25"
        y="25"
      />
    </g>
  </SvgIcon>
);
